<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv">
            <template v-if="isload">
                <div class="account">
                    <div class="part">
                        <div class="left">
                            <dl>
                                <dt><i class="iconfont icon-mobile-phone"></i></dt>
                                <dd>
                                    <span class="a">
                                        <span class="a1">{{$common.dicword('mobile')}}</span>
                                        <span class="a2">{{me.mobile||$common.dicword('notbind')}}</span>
                                    </span>
                                    <span class="b">{{$common.dicword('mobileforpwd')}}</span>
                                </dd>
                            </dl>
                        </div>
                        <div class="right"><router-link to="/member/mobile">{{$common.dicword('modify')}}</router-link></div>
                    </div>
                    <div class="part">
                        <div class="left">
                            <dl>
                                <dt><i class="iconfont icon-lock"></i></dt>
                                <dd>
                                    <span class="a">
                                        <span class="a1">{{$common.dicword('pwd')}}</span>
                                    </span>
                                    <span class="b">{{$common.dicword('protectaccount')}}</span>
                                </dd>
                            </dl>
                        </div>
                        <div class="right"><router-link to="/member/password">{{$common.dicword('modify')}}</router-link></div>
                    </div>
                </div>
            </template>
        </Cmember>
    </div>

</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'account',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 8,
                me: {}
            };
        },
        methods: {
            getdata: function () {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofile' } };
                this.$common.post(jsondata, res => {

                    res.infodata.birth = this.$common.basic.dateformat(res.infodata.birth);// || '2000-01-01';
                    this.me = res.infodata || {};

                    this.isload = true;
                });
            }
        },
        mounted() {
            this.getdata();
        }
    }

</script>
